import { render, staticRenderFns } from "./FakturPajakUpload.vue?vue&type=template&id=07f56400&scoped=true"
import script from "./FakturPajakUpload.vue?vue&type=script&lang=js"
export * from "./FakturPajakUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f56400",
  null
  
)

export default component.exports